module.exports = __webpack_public_path__ + "static/media/team-img1.9abc4ee7.jpg";